import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { dialogFormColumn } from '../../../theme/mixins';

export const dialogTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
};

/** Lets the fields scroll under a pinned footer -- see `dialogFormColumn`. */
export const dialogFormStyles: SxProps<Theme> = dialogFormColumn;

export const formAlertStyles: SxProps<Theme> = {
    mb: 2,
};

export const fieldsBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    pt: 1,
    mb: 3,
};

export const descriptionStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 1,
};

/** The list scrolls rather than the dialog growing, as the therapist services list does. */
export const choicesBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 320,
    overflowY: 'auto',
};

export const choiceContextStyles: SxProps<Theme> = {
    color: 'text.secondary',
    ml: 1,
};

export const blockedHintStyles: SxProps<Theme> = {
    mr: 'auto',
};

export const dialogActionsStyles: SxProps<Theme> = {
    px: 3,
    pb: 3,
    pt: 1,
    gap: 1,
};
